import {Injectable} from '@angular/core';
import {Project} from '../model/project.model';
import {ApiService} from './api.service';
import {retryAfterMillis} from '../shared/constants';
import {utf8Decode} from 'sdv-common';

@Injectable({providedIn: 'root'})
export class ProjectService {

  private projects: Project[] = [];

  constructor(private apiService: ApiService) {
    this.load();
  }

  load() {
    this.apiService.get('projects')
      .subscribe(response => {
        const projects: Project[] = [];
        for (const project of response) {
          projects.push(this.convertProject(project));
        }
        this.projects = projects;
      }, err => {
        this.apiService.error({}, err);
        setTimeout(() => this.load(), retryAfterMillis);
      });
  }

  getName(id) {
    for (const project of this.projects) {
      if (id === project.id) {
        return project.name;
      }
    }
    return '';
  }

  private convertProject(project) {
    return {
      id: utf8Decode(project.id || ''),
      name: utf8Decode(project.name || ''),
      description: utf8Decode(project.description || '')
    };
  }

  getProjects() {
    return this.projects;
  }

  create($e, project) {
    this.apiService.post('projects', {
      description: project.description,
      name: project.name
    }).subscribe(project => {
      this.projects.push(this.convertProject(project));
      $e.target.parentNode.querySelector('[data-bs-dismiss]')
        .dispatchEvent(new Event('click'));
    }, err => {
      this.apiService.error(project, err);
    });
  }
}
